export enum GameEdition {
	GLOBAL,
	KOREAN,
	CHINESE,
}
